import { render, staticRenderFns } from "./FieldExerciseQuestions.vue?vue&type=template&id=3716a831&scoped=true"
import script from "./FieldExerciseQuestions.vue?vue&type=script&lang=js"
export * from "./FieldExerciseQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3716a831",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3716a831')) {
      api.createRecord('3716a831', component.options)
    } else {
      api.reload('3716a831', component.options)
    }
    module.hot.accept("./FieldExerciseQuestions.vue?vue&type=template&id=3716a831&scoped=true", function () {
      api.rerender('3716a831', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldExerciseQuestions.vue"
export default component.exports